import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import { fetchNewSessionPayment } from "../../../services/rest/membership/membershipService";
import Loading from "../../Loading/Loading";
import { useSelector } from "react-redux";
import {
  Box,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

import InsigniaMembresia from "../../../assets/images/temporalImages/GoldInsignia.png";
import { useLocation } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ModalSuccessPayment from "./ModalSuccessPayment";
import ModalFiledPayment from "./ModalFiledPayment";

// ⚠️ Asegúrate de que la PK esté definida en .env
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const MembreshipOfUser = () => {
  // ────────────────────────────────────────────────────────────────────────────
  // Global state & routing
  // ────────────────────────────────────────────────────────────────────────────
  const location = useLocation();
  const membership = location.state?.membership;

  const {
    _id: currentMembershipId,
    planName: currentPlanName,
    price: currentPrice,
    currency: currentCurrency,
    description: currentDescription,
    routeLimit: currentRouteLimit,
  } = useSelector((state) => state.membershipReducer);

  const { _id: userId } = useSelector((state) => state.userReducer);
  const [loading, setLoading] = useState(true);
  const [autoRenew, setAutoRenew] = useState(true);
  const [customerId, setCustomerId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [open, setOpen] = useState(false);
  const [openFiled, setOpenFiled] = useState(false);

  const [selectedMembership, setSelectedMembership] = useState({
    _id: currentMembershipId,
    planName: currentPlanName,
    price: currentPrice,
    routeLimit: currentRouteLimit,
    currency: currentCurrency,
    description: currentDescription,
  });

  const handleOpen = () => setOpen(true);
  const hanleOpenFiled = () => setOpenFiled(true);
  const initializePaymentSheet = async ({
    membershipType,
    userId,
    isAutoRenew,
  }) => {
    try {
      // Indicamos que comenzamos una nueva petición
      setLoading(true);
      console.log("Membresia para paymentIntent", membershipType);

      const response = await fetchNewSessionPayment({
        membershipType,
        userId,
        isAutoRenew,
      });

      setCustomerId(response?.customerId);
      setSessionId(response?.sessionId);
    } catch (error) {
      console.error("initializePaymentSheet error", error);
    } finally {
      setLoading(false);
    }
  };

  // ────────────────────────────────────────────────────────────────────────────
  // Efecto de carga inicial (mount)
  // ────────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    // 1️⃣  Definir qué membresía mostrar (si el usuario ya tiene una o viene de la ruta "upgrade")
    console.log("Autorenovacion", autoRenew);

    if (membership === undefined) {
      console.log("Si paga si Membresia seleccionada usuario", membership);
      setSelectedMembership({
        _id: currentMembershipId,
        planName: currentPlanName,
        price: currentPrice,
        routeLimit: currentRouteLimit,
        currency: currentCurrency,
        description: currentDescription,
      });

      initializePaymentSheet({
        membershipType: currentPlanName,
        userId,
        isAutoRenew: autoRenew,
      });
    } else {
      console.log("Nueva  Membresia seleccionada usuario", membership);
      // El usuario viene desde una membresía seleccionada en otra pantalla
      setSelectedMembership({
        _id: membership?._id,
        planName: membership?.planName,
        price: membership?.price,
        routeLimit: membership?.routeLimit,
        currency: membership?.currency,
        description: membership?.description,
      });

      initializePaymentSheet({
        membershipType: membership?.planName,
        userId,
        isAutoRenew: autoRenew,
      });
    }
  }, [autoRenew]);

  // useEffect(() => {
  //   // Evitamos ejecutar si todavía no tenemos los datos necesarios
  //   if (!selectedMembership?.planName || !userId) return;
  //   console.log("Renderizado de auto rernovacion", selectedMembership);

  //   initializePaymentSheet({
  //     membershipType: selectedMembership.planName,
  //     userId,
  //     isAutoRenew: autoRenew,
  //   });
  // }, [autoRenew]);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        justifyContent: "center",
        gap: 5,
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Loader global */}
      <Loading loading={loading} />

      {/* Modal de éxito */}
      <ModalSuccessPayment
        open={open}
        setOpen={setOpen}
        selectedMembership={selectedMembership}
      />
      {/*Modal de fallo */}
      <ModalFiledPayment
        open={openFiled}
        setOpen={setOpenFiled}
        selectedMembership={selectedMembership}
      />

      {/* Columna izquierda: Checkout */}
      <Box sx={{ width: { lg: "45%" } }}>
        <Box
          sx={{
            p: 2,
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            borderRadius: 5,
          }}
        >
          {customerId && (
            <Elements
              stripe={stripePromise}
              options={{
                clientSecret: sessionId,
                customerSessionClientSecret: customerId,
                appearance: { theme: "night" },
              }}
            >
              <CheckoutForm
                setLoading={setLoading}
                handleOpen={handleOpen}
                hanldeOpenFiled={hanleOpenFiled}
                selectedMembership={selectedMembership}
                // autoRenew={autoRenew}
                // setAutoRenew={setAutoRenew}
              />
            </Elements>
          )}
        </Box>
      </Box>

      {/* Columna derecha: Detalle de membresía */}
      <Box
        sx={{
          p: 2,
          backgroundColor: "rgba(128, 128, 128, 0.55)",
          borderRadius: 5,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", gap: 4, justifyContent: "center" }}>
          <Box>
            <img
              src={InsigniaMembresia}
              alt="Insignia de membresía"
              width={200}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography>Membresía</Typography>
            <Chip
              label={selectedMembership?.planName ?? "Free"}
              sx={{ backgroundColor: "#e7ef7d", color: "black" }}
            />
            <Typography sx={{ color: "#e7ef7d" }} variant="h4">
              ${selectedMembership?.price}
            </Typography>
          </Box>
        </Box>

        <Typography textAlign="center">
          {selectedMembership?.routeLimit} Rutas Disponibles
        </Typography>

        <List>
          {selectedMembership?.description.map((item, idx) => (
            <ListItem disablePadding key={idx}>
              <ListItemButton>
                <ListItemIcon>
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText primary={item} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default MembreshipOfUser;
